var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechMedical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color_5_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.3,348.1c-4.9,0-8.9,4-8.9,8.9c0,4.9,4,8.9,8.9,8.9c4.9,0,8.9-4,8.9-8.9 C170.2,352.1,166.2,348.1,161.3,348.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.3,401.7c-4.9,0-8.9,4-8.9,8.9c0,4.9,4,8.9,8.9,8.9c4.9,0,8.9-4,8.9-8.9 C170.2,405.7,166.2,401.7,161.3,401.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.3,294.6c-4.9,0-8.9,4-8.9,8.9c0,4.9,4,8.9,8.9,8.9c4.9,0,8.9-4,8.9-8.9 C170.2,298.6,166.2,294.6,161.3,294.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.1,348.1c-4.9,0-8.9,4-8.9,8.9c0,4.9,4,8.9,8.9,8.9s8.9-4,8.9-8.9C117,352.1,113,348.1,108.1,348.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.1,294.6c-4.9,0-8.9,4-8.9,8.9c0,4.9,4,8.9,8.9,8.9s8.9-4,8.9-8.9C117,298.6,113,294.6,108.1,294.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.9,285.7c4.9,0,8.9-4,8.9-8.9c0-4.9-4-8.9-8.9-8.9c-4.9,0-8.9,4-8.9,8.9 C179.1,281.7,183,285.7,187.9,285.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M214.5,419.5c4.9,0,8.9-4,8.9-8.9c0-4.9-4-8.9-8.9-8.9s-8.9,4-8.9,8.9C205.7,415.5,209.6,419.5,214.5,419.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.9,232.2c4.9,0,8.9-4,8.9-8.9c0-4.9-4-8.9-8.9-8.9c-4.9,0-8.9,4-8.9,8.9 C179.1,228.2,183,232.2,187.9,232.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M241.1,339.2c4.9,0,8.9-4,8.9-8.9c0-4.9-4-8.9-8.9-8.9c-4.9,0-8.9,4-8.9,8.9 C232.3,335.2,236.2,339.2,241.1,339.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M241.1,285.7c4.9,0,8.9-4,8.9-8.9c0-4.9-4-8.9-8.9-8.9c-4.9,0-8.9,4-8.9,8.9 C232.3,281.7,236.2,285.7,241.1,285.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "neutral_7_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M134.7,267.8c-4.9,0-8.9,4-8.9,8.9c0,4.9,4,8.9,8.9,8.9c4.9,0,8.9-4,8.9-8.9 C143.6,271.8,139.6,267.8,134.7,267.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M161.3,241.1c-4.9,0-8.9,4-8.9,8.9c0,4.9,4,8.9,8.9,8.9c4.9,0,8.9-4,8.9-8.9 C170.2,245.1,166.2,241.1,161.3,241.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 134.7,
    cy: 330.3,
    rx: 8.9,
    ry: 8.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 81.5,
    cy: 330.3,
    rx: 8.9,
    ry: 8.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.3,339.2c4.9,0,8.9-4,8.9-8.9c0-4.9-4-8.9-8.9-8.9c-4.9,0-8.9,4-8.9,8.9 C285.5,335.2,289.4,339.2,294.3,339.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.5,374.9c-4.9,0-8.9,4-8.9,8.9c0,4.9,4,8.9,8.9,8.9c4.9,0,8.9-4,8.9-8.9C90.4,378.9,86.4,374.9,81.5,374.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.1,401.7c-4.9,0-8.9,4-8.9,8.9c0,4.9,4,8.9,8.9,8.9s8.9-4,8.9-8.9C117,405.7,113,401.7,108.1,401.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M134.7,374.9c-4.9,0-8.9,4-8.9,8.9c0,4.9,4,8.9,8.9,8.9c4.9,0,8.9-4,8.9-8.9 C143.6,378.9,139.6,374.9,134.7,374.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M267.7,366c4.9,0,8.9-4,8.9-8.9c0-4.9-4-8.9-8.9-8.9c-4.9,0-8.9,4-8.9,8.9C258.9,362,262.8,366,267.7,366z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M187.9,339.2c4.9,0,8.9-4,8.9-8.9c0-4.9-4-8.9-8.9-8.9c-4.9,0-8.9,4-8.9,8.9 C179.1,335.2,183,339.2,187.9,339.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M187.9,392.7c4.9,0,8.9-4,8.9-8.9c0-4.9-4-8.9-8.9-8.9c-4.9,0-8.9,4-8.9,8.9 C179.1,388.7,183,392.7,187.9,392.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M426.6,72.4c-23.4-23.5-54.5-36.5-87.5-36.5c-33,0-64.1,13-87.5,36.5c-7,7.1-170.7,171.7-178.1,179.2 c-48.2,48.5-48.2,127.5,0,176.1c23.4,23.5,54.5,36.5,87.5,36.5c33,0,64.1-12.9,87.5-36.5c6-6.1,170.6-171.7,178.1-179.2 C474.8,199.9,474.8,120.9,426.6,72.4z M235.9,415c-11.4,11.4-25,19.9-39.7,25.1c0.3-0.9,0.6-1.8,0.6-2.8c0-4.9-4-8.9-8.9-8.9 c-4.9,0-8.9,4-8.9,8.9c0,2.7,1.3,5.1,3.2,6.7c-7,1.4-14.1,2.2-21.3,2.2c-7.1,0-14-0.7-20.8-2c2-1.6,3.4-4,3.4-6.9 c0-4.9-4-8.9-8.9-8.9c-4.9,0-8.9,4-8.9,8.9c0,1.1,0.3,2.1,0.6,3.1c-15.1-5.2-28.9-13.7-40.5-25.4c-14.1-14.2-23.3-31.5-27.8-49.7 c3.3-1.3,5.6-4.5,5.6-8.3c0-4.8-3.7-8.6-8.4-8.8c-1-12.3,0.2-24.8,3.4-36.8c2.9-1.5,5-4.4,5-7.9c0-1.5-0.5-2.8-1.1-4.1 c2.8-6.9,6.3-13.5,10.5-19.8c1.2,3.5,4.4,6,8.3,6c4.9,0,8.9-4,8.9-8.9c0-4.6-3.5-8.2-7.9-8.7c1.2-1.3,2.2-2.6,3.5-3.9 c1.1-1.1,6-6.1,13.4-13.5c0.3,4.6,4.1,8.3,8.7,8.3c4.9,0,8.9-4,8.9-8.9c0-4.7-3.6-8.4-8.2-8.8c5.1-5.2,10.9-11,17.2-17.3 c0.3,4.6,4.1,8.3,8.7,8.3c4.9,0,8.9-4,8.9-8.9c0-4.7-3.6-8.4-8.2-8.8c5.5-5.6,11.3-11.4,17.2-17.3c0.4,4.6,4.1,8.3,8.7,8.3 c4.9,0,8.9-4,8.9-8.9c0-4.7-3.6-8.4-8.2-8.8c5.2-5.2,10.4-10.5,15.6-15.7l150,150.9C283.7,367,239,411.9,235.9,415z M414.1,235.8 c-3.3,3.3-36.8,37-73.9,74.4l-150-150.9c37.2-37.4,70.8-71.2,73.9-74.4c20-20.2,46.7-31.2,75-31.2c28.3,0,55,11.1,75,31.2 C455.4,126.6,455.4,194.3,414.1,235.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 214.5,
    cy: 303.5,
    rx: 8.9,
    ry: 8.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M241.1,392.7c4.9,0,8.9-4,8.9-8.9c0-4.9-4-8.9-8.9-8.9c-4.9,0-8.9,4-8.9,8.9 C232.3,388.7,236.2,392.7,241.1,392.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 267.7,
    cy: 303.5,
    rx: 8.9,
    ry: 8.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M214.5,366c4.9,0,8.9-4,8.9-8.9c0-4.9-4-8.9-8.9-8.9s-8.9,4-8.9,8.9C205.7,362,209.6,366,214.5,366z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 214.5,
    cy: 250,
    rx: 8.9,
    ry: 8.9
  })))));
}

export default SvgAlvotechMedical;